// extracted by mini-css-extract-plugin
module.exports = {"container":"Ranking_container__YVi7w","icon":"Ranking_icon__IqwQF","type_name":"Ranking_type_name__2tHQg"};